export default "__VITE_ASSET__BDRR5b0H__"